<script setup>
    import { onMounted } from 'vue';
    import mapboxgl from 'mapbox-gl';
    import { MapStyle, Map } from '@/lib/constants/constants';

    const props = defineProps({
        mapData: Object,
        mapStyle: {
            type: String,
            required: true,
            validator: (value) => Object.values(MapStyle).includes(value)
        }
    });

    onMounted(() => {
        initMap();
    });

    const initMap = () => {
        mapboxgl.accessToken = Map.ACCESS_TOKEN;

        var map = new mapboxgl.Map({
            container: 'map',
            style: props.mapStyle,
            center: [
                props.mapData?.features[0].geometry.coordinates[0],
                props.mapData?.features[0].geometry.coordinates[1]
            ],
            zoom: 5
        });

        map.on('load', () => {
            map.scrollZoom.disable();
            map.addControl(new mapboxgl.NavigationControl(), 'top-right');
            map.addControl(
                new mapboxgl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    trackUserLocation: true
                }),
                'top-right'
            );

            map.addControl(
                new mapboxgl.ScaleControl({
                    maxWidth: 100,
                    unit: 'metric'
                })
            );

            map.resize();
        });

        // add markers to map
        for (const feature of props.mapData?.features) {
            // create a HTML element for each feature
            const el = document.createElement('div');
            el.className = 'marker';

            // toggle active marker when clicked
            el.addEventListener('click', (ev) => {
                var cc = map.getContainer();
                var els = cc.getElementsByClassName('marker');
                for (var i = 0; i < els.length; i++) {
                    var otherItem = els.item(i);
                    otherItem.classList.remove('active');
                }
                el.classList.toggle('active');
            });

            // make a marker for each feature and add it to the map
            new mapboxgl.Marker(el)
                .setLngLat(feature.geometry.coordinates)
                .setPopup(
                    new mapboxgl.Popup({ offset: 25 }) // add popups
                        .setHTML(toHtml(feature))
                )
                .addTo(map);
        }
    };

    const toHtml = (feature) => {
        var html = `<a href="${feature.properties.url}">`;
        html += `<div class="fakta">`;
        html += `<h2>${feature.properties.title}</h2>`;
        feature.properties.architects.forEach((firm) => {
            html += `<p class="fakta-gray">${firm}</p>`;
        });
        if (feature.properties.image.url !== undefined && feature.properties.image.url !== null) {
            html += `<img src="${feature.properties.image.url}" alt="${feature.properties.image.alt}" />`;
        }

        html += `</div>`;
        html += `</a>`;

        return html;
    };
</script>

<template>
    <div class="map-container">
        <div id="map"></div>
    </div>
</template>
